<template>
	<GridLayout :sidebar-state="false">
		<template #right-header>
			<div class="w-full h-full flex items-center gap-3">
				<button
					class="btn btn-rounded"
					@click="Previous"
				>
					<i class="fas fa-chevron-left"></i>
				</button>
				<Steps
					:steps-map="stepsMap"
					:current-step="currentStep"
					@select-step="
						currentStep = $event
						autoNav = false
					"
				/>
			</div>
		</template>
		<template #right-content>
			<Patient
				v-if="step === 'patient'"
				:patient-id="reception_flow_data.patient_id || null"
				:auto-nav="autoNav"
				:patient="selected.patient"
				class="w-full flex-1 flex flex-col"
				@next="WalkStep"
				@change:autoNav="autoNav = $event"
			/>

			<MainContent v-else-if="selected.patient">
				<History :patient="selected.patient" />
			</MainContent>
		</template>
		<template #right-footer>
			<div
				v-if="isReceptionFlow"
				class="w-full h-full flex items-center"
			>
				<div class="h-full flex gap-3">
					<button
						class="btn btn-danger btn-fixed-size"
						:disabled="reception_flow_data?.is_finished"
						@click="CancelFlow()"
					>
						SUSPENDER
					</button>
				</div>
				<div class="flex-1 h-full flex justify-end">
					<button
						class="btn btn-success btn-fixed-size"
						:disabled="!reception_flow_data?.is_finishable"
						@click="FinishFlow()"
					>
						CONCLUIR
					</button>
				</div>
			</div>
		</template>
	</GridLayout>
</template>

<script>
	import receptionFlowMixin from '@/mixins/receptionFlow'

	import Patient from '@/components/shared/scheduling/Patient'
	import History from '@/components/patient/components/History'

	export default {
		name: 'ExamResult',
		mixins: [receptionFlowMixin],
		components: {
			Patient,
			History,
		},
		data() {
			return {
				search: '',
				selected: {
					patient: null,
				},
				currentStep: 0,
				autoNav: true,
				stepsMap: [
					{
						key: 'pre',
					},
					{
						key: 'patient',
						number: 1,
						label: 'PACIENTE',
						isValid: false,
					},
					{
						key: 'results',
						number: 2,
						label: 'RESULTADOS',
						isValid: true,
					},
				],
			}
		},
		computed: {
			step() {
				return this.stepsMap[this.currentStep].key
			},
		},
		methods: {
			Previous() {
				switch (this.step) {
					case 'patient':
						this.$router.push({ name: 'Home' })
						break
					case 'results':
						this.currentStep--
						break
				}

				this.autoNav = false
			},
			WalkStep(param) {
				switch (this.stepsMap[this.currentStep].key) {
					case 'pre':
						if (this.isReceptionFlow) {
							this.currentStep = 1
						} else {
							this.currentStep = 2
						}

						break
					case 'patient':
						this.selected.patient = param.patient

						this.stepsMap[this.currentStep].isValid = true
						if (param.autoWalkStep) this.currentStep++
						break
				}

				this.autoNav = true
			},
		},
		async beforeMount() {
			await this.HandleReceptionFlow()
			this.reception_flow_data.is_finishable = true

			this.WalkStep()
		},
	}
</script>

<style lang="scss" scoped>
	:deep(.new-datatable) {
		max-height: 46.3rem;
	}
</style>
